import { render, staticRenderFns } from "./Riders.vue?vue&type=template&id=c8cfe03a&scoped=true"
import script from "./Riders.vue?vue&type=script&lang=js"
export * from "./Riders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8cfe03a",
  null
  
)

export default component.exports